// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  collection,
  getDocs,
  getFirestore,
  query,
  where,
} from "firebase/firestore";
import "firebase/auth";
import { getAuth, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { toast } from "react-toastify";
import { getMessaging } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
export const db = getFirestore(app);
export const messaging = getMessaging();

export const loginAuth = async (email, password, navigate) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    const role = (
      await getDocs(
        query(collection(db, "users"), where("uid", "==", user.uid)),
      )
    ).docs[0]?.data();

    const response = { ...user, role: role?.role ?? "user" };
    navigate({ to: "/dashboard" , resetScroll: true});
    return response;
  } catch (error) {
    // Re-throw the error so it can be handled by the mutation
    throw error;
  }
};

export const logout = async () => {
  let response = null;
  await signOut(auth)
    .then((e) => {
      response = true;
    })
    .catch((error) => {
      toast.error(error?.error || error?.message);
      // An error happened.
    });
  return response;
};
